import { render } from "./SalaryReportsIndex.vue?vue&type=template&id=571cb7f8&ts=true"
import script from "./SalaryReportsIndex.vue?vue&type=script&lang=ts"
export * from "./SalaryReportsIndex.vue?vue&type=script&lang=ts"

import "./SalaryReportsIndex.vue?vue&type=style&index=0&id=571cb7f8&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__